module.exports = __webpack_public_path__ + "media/img/private-venue/private-6d8d55086fb3bc6b3a6baf19d45828ed.svg";